import { isArchivedRequest } from "./tenderFormatters";

// Returns the id of the single most-recently-created tender in a list
// (max created_at / created_on), or null. Used to badge "Newest" on exactly
// one card / list row. Auto-moves as the list changes; ties resolve to the
// higher id (latest insert).
//
// Terminal (archived) rows never win: NEWEST marks the freshest row in a
// FEED, and an ended request is in no feed. The club's Active tab now
// filters server-side (status=active, disjoint lifecycle tabs per the
// archive handoff), so a terminal row normally cannot even reach it any
// more — this guard stays as the defensive rule for ANY list that might
// still hold one. Decided HERE rather than at the call sites, so no list
// can hand NEWEST to an ended row.
export function newestTenderId(tenders) {
  if (!Array.isArray(tenders) || tenders.length === 0) return null;
  let bestId = null;
  let bestTime = -Infinity;
  for (const t of tenders) {
    if (isArchivedRequest(t)) continue;
    const raw = t?.created_on || t?.created_at;
    const time = raw ? new Date(raw).getTime() : NaN;
    if (!Number.isFinite(time)) continue;
    if (time > bestTime || (time === bestTime && (t.id || 0) > (bestId || 0))) {
      bestTime = time;
      bestId = t.id;
    }
  }
  return bestId;
}
